<template>
    <section class="wrap">
        <section class="container">
            <section class="nav-title">
                <router-link class="nav-item" to="/">首页</router-link>
                <router-link class="nav-item" to="/introduction">机构简介</router-link>
                <div style="position: relative;" :class="hover === true ? 'hover' : ''" @mouseenter="hover = true" @mouseleave="hover = false">
                    <div class="nav-item">业务介绍</div>
                    <div v-if="hover" class="hover-wrap">
                        <router-link class="sub-item" to="/unified-assessment">统一评估</router-link>
                        <a class="sub-item" href="http://www.shgpo.com/" target="_blank">G P O</a>
                    </div>
                </div>
                <router-link class="nav-item" :to="{name:'list',query:{tag: 'information-query'}}">信息查询</router-link>
                <router-link class="nav-item" :to="{name:'list',query:{tag: 'policy_advocacy'}}">政策宣传</router-link>
                <router-link class="nav-item" :to="{name:'list',query:{tag: 'honest-service'}}">诚信服务</router-link>
                <router-link class="nav-item" to="/suggest">投诉咨询</router-link>
            </section>
        </section>
    </section>
</template>

<script>
    export default {
        data() {
            return {
                hover: false
            }
        }
    }
</script>

<style>
    .nav-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 1.625rem;
        margin-bottom: 3.5rem;
    }

    .nav-item {
        cursor: pointer;
        color: #ffffff;
        font-size: 1.5rem;
        font-family: Adobe Heiti Std;
        text-decoration: none;
    }

    .hover-wrap {
        position: absolute;
        display: flex;
        width: 20rem;
    }

    .sub-item {
        font-size: 1rem;
        margin-right: 3rem;
    }

    .wrap {
        background-color: #BD1A2D;
        overflow: hidden;
    }

    .sub-item {
        font-size: 1.3rem;
        color: #fff;
        height: 4rem;
        line-height: 4rem;
        text-align: center;
        margin-left: 1rem;
    }

    .hover {
        border-bottom: 2px solid #f5d389;
    }
    
    .sub-item:hover {
        color: #f5d389;
    }
</style>
